<template>
    <div class="block w-full">
        <!-- list payment methods -->
        <div class="sm:rounded-lg">
            <div class="px-4 py-5 sm:p-6">
                <h3 class="text-base font-semibold leading-6 text-gray-900">Select Payment Method</h3>
                <div class="mt-5">
                    <div class="flex flex-col gap-4">
                        <template v-if="selectedPaymentMethod && !state.showAll">
                            <CreditCard
                                aria-role="button"
                                class="border-2 border-transparent border-blue-500 cursor-pointer"
                                :paymentMethod="selectedPaymentMethod"
                                @click="emit('update:modelValue', selectedPaymentMethod.id)"
                            />
                            <button
                                v-if="!state.showAll && paymentMethods.length > 1"
                                type="button"
                                class="button"
                                key="btn-next"
                                @click="state.showAll = true"
                            >
                                Show More ({{ paymentMethods.length }})
                            </button>
                        </template>
                        <template v-else>
                            <div
                                v-for="paymentMethod in paymentMethods"
                                :key="paymentMethod.id"
                                class="w-full"
                            >
                                <CreditCard
                                    aria-role="button"
                                    class="border-2 border-transparent hover:border-blue-500 cursor-pointer"
                                    :class="{ 'border-blue-600': paymentMethod.id === modelValue }"
                                    :paymentMethod="paymentMethod"
                                    @click="emit('update:modelValue', paymentMethod.id)"
                                />
                            </div>
                        </template>

                        <button
                            v-if="state.showAll && paymentMethods.length > 1"
                            type="button"
                            class="button"
                            key="btn-show-less"
                            @click="state.showAll = false"
                        >
                            Show Less
                        </button>

                        <button
                            type="button"
                            class="button button--secondary"
                            key="btn-next"
                            @click="emit('new')"
                        >
                            New Payment Method
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import CreditCard from '@/components/PaymentMethod/CreditCard.vue'
import { computed, reactive } from 'vue'

interface Props {
    paymentMethods: stripe.paymentMethod.PaymentMethod[]
    modelValue: string | null
}

const props = defineProps<Props>()

const emit = defineEmits<{
    (event: 'update:modelValue', value: string): void,
    (event: 'new'): void,
}>()

const state = reactive({
    showAll: false,
})

const selectedPaymentMethod = computed(() => {
    return props.paymentMethods.find((paymentMethod) => paymentMethod.id === props.modelValue)
})
</script>
